import {
  ChangeDetectionStrategy,
  Component,
  effect,
  ElementRef,
  input,
  viewChild,
} from '@angular/core';
import * as QRCode from 'qrcode';

@Component({
  selector: 'cmo-qr-canvas',
  templateUrl: './qr-canvas.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QrCanvasComponent {
  readonly url = input<string | null>(null);
  /** ダウンロード時のファイル名（拡張子込み）。 */
  readonly downloadFileName = input('invite-qr.png');

  private readonly canvasRef =
    viewChild<ElementRef<HTMLCanvasElement>>('canvas');

  constructor() {
    effect(() => {
      const u = this.url();
      if (!u) return;
      const draw = (canvas: HTMLCanvasElement) => {
        const url = this.url();
        if (!url) return;
        const opts = {
          width: 200,
          margin: 1,
          color: { dark: '#000000', light: '#ffffff' },
        };
        const applyToCanvas = (dataUrl: string) => {
          if (!canvas.isConnected) return;
          const img = new Image();
          img.onload = () => {
            if (!canvas.isConnected) return;
            const ctx = canvas.getContext('2d');
            if (!ctx) return;
            ctx.fillStyle = '#ffffff';
            ctx.fillRect(0, 0, 200, 200);
            ctx.drawImage(img, 0, 0, 200, 200);
          };
          img.onerror = () => undefined;
          img.src = dataUrl;
        };
        const onError = (): undefined => undefined;
        try {
          const p = QRCode.toDataURL(url, opts);
          if (typeof (p as Promise<string> | undefined)?.then === 'function') {
            (p as Promise<string>).then(applyToCanvas).catch(() => onError());
          } else {
            QRCode.toDataURL(
              url,
              opts,
              (err: Error | null | undefined, dataUrl: string) => {
                if (err) onError();
                else applyToCanvas(dataUrl);
              },
            );
          }
        } catch {
          onError();
        }
      };
      const scheduleDraw = (canvasEl: HTMLCanvasElement) => {
        requestAnimationFrame(() => {
          try {
            draw(canvasEl);
          } catch {
            /* 描画失敗: プロジェクト方針により console は出さない */
          }
        });
      };
      const el = this.canvasRef()?.nativeElement;
      if (el) {
        scheduleDraw(el);
      } else {
        setTimeout(() => {
          const canvas = this.canvasRef()?.nativeElement;
          if (canvas) scheduleDraw(canvas);
        }, 200);
      }
    });
  }

  download(): void {
    const el = this.canvasRef()?.nativeElement;
    if (!el || el.width === 0) return;
    const dataUrl = el.toDataURL('image/png');
    const link = document.createElement('a');
    link.href = dataUrl;
    link.download = this.downloadFileName();
    link.click();
  }
}
